import { Plus } from 'lucide-react'
import { ToolbarItem } from '../../../common/components/ToolbarItem'
import { FC } from 'react'
import { Tooltip } from '../../../common/components/Tooltip'
import { getRoute } from '@wellesley/router'

const AddGroupButton: FC = () => {
  return (
    <>
      <Tooltip tooltipText="Add groups">
        <ToolbarItem
          id="add-group"
          name="Add groups"
          link={getRoute('/discover/:category', { category: 'popular' })}
          Icon={Plus}
        />
      </Tooltip>
    </>
  )
}

export default AddGroupButton
